import { render, staticRenderFns } from "./MessageLogcopy.vue?vue&type=template&id=98151586&"
import script from "./MessageLogcopy.vue?vue&type=script&lang=js&"
export * from "./MessageLogcopy.vue?vue&type=script&lang=js&"
import style0 from "./MessageLogcopy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MessageLogcopy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports